import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbTipoCredencial } from "app/abstract/full-pages/credencial/tipo-credencial.abstract";

@Injectable({ providedIn: 'root' })
export class TipoCredencialService extends AbTipoCredencial {
    prefixo = 'tipo_credenciais/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getAllTipoCredenciais() {
        return this.get(this.prefixo + "all/ativo");
    }

    public getAllTipoCredenciaisPromise() {
        return this.getAllTipoCredenciais().toPromise();
    }

    public getAllColeta() {
        return this.get(this.prefixo + "all/coleta");
    }

    public getAllNaoColeta(): Observable<any> {
        return this.get(this.prefixo + "all/nao_coleta");
    }
}